import { SegmentTracker } from '@varsitytutors/event-tracker';

export const tracker = new SegmentTracker(process.env.VITE_SEGMENT_SOURCE_WRITE_KEY || '');
